<section class="menu-card">
  <article>
    <svg-icon
      src="assets/svg/pin-info.svg"
      class="aspect-square w-4 cursor-pointer self-end"
      (click)="openModal()"
    ></svg-icon>

    <img
      loading="lazy"
      src="assets/rush/5K-gold-coins-in-pot.png"
      alt="Table illustration"
      class="h-[140x] w-[140px] self-center"
    />

    <div>
      <h2>Coming Soon</h2>
      <div class="info">
        <svg-icon src="assets/svg/pot.svg"></svg-icon>
        <div>-</div>
      </div>
      <div class="info">
        <svg-icon src="assets/svg/coins.svg" class="mr-2"></svg-icon>
        <div>-</div>
      </div>
      <div class="info">
        <svg-icon src="assets/svg/coins.svg" class="mr-2"></svg-icon>
        <div>-</div>
      </div>
      <div class="h-28"></div>

      <div class="closed">CLOSED</div>
    </div>
  </article>
</section>
